<script>
/* eslint-disable no-unused-vars, no-console, vue/no-bare-strings-in-template */
import { mapGetters } from 'vuex';
import { shouldBeUrl } from 'shared/helpers/Validators';
import { useAlert } from 'dashboard/composables';
import { useVuelidate } from '@vuelidate/core';
import SettingIntroBanner from 'dashboard/components/widgets/SettingIntroBanner.vue';
import SettingsToggleSection from 'dashboard/components-next/Settings/SettingsToggleSection.vue';
import SettingsFieldSection from 'dashboard/components-next/Settings/SettingsFieldSection.vue';
import SettingsAccordion from 'dashboard/components-next/Settings/SettingsAccordion.vue';
import inboxMixin from 'shared/mixins/inboxMixin';
import FacebookReauthorize from './facebook/Reauthorize.vue';
import InstagramReauthorize from './channels/instagram/Reauthorize.vue';
import TiktokReauthorize from './channels/tiktok/Reauthorize.vue';
import DuplicateInboxBanner from './channels/instagram/DuplicateInboxBanner.vue';
import MicrosoftReauthorize from './channels/microsoft/Reauthorize.vue';
import GoogleReauthorize from './channels/google/Reauthorize.vue';
import WhatsappReauthorize from './channels/whatsapp/Reauthorize.vue';
import InboxHealthAPI from 'dashboard/api/inboxHealth';
import PreChatFormSettings from './PreChatForm/Settings.vue';
import WeeklyAvailability from './components/WeeklyAvailability.vue';
import GreetingsEditor from 'shared/components/GreetingsEditor.vue';
import ConfigurationPage from './settingsPage/ConfigurationPage.vue';
import CustomerSatisfactionPage from './settingsPage/CustomerSatisfactionPage.vue';
import NetPromoterScorePage from './settingsPage/NetPromoterScorePage.vue';
import CollaboratorsPage from './settingsPage/CollaboratorsPage.vue';
import MessageTemplatesPage from './settingsPage/messageTemplates/MessageTemplatesPage.vue';
import BotConfiguration from './components/BotConfiguration.vue';
import ChannelAvatarField from './components/ChannelAvatarField.vue';
import AccountHealth from './components/AccountHealth.vue';
import WhatsappManualMigrationDialog from './components/WhatsappManualMigrationDialog.vue';
import WhatsappManualMigrationBanner from './components/WhatsappManualMigrationBanner.vue';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import SenderNameExamplePreview from './components/SenderNameExamplePreview.vue';
import LockToSingleConversationPreview from './components/LockToSingleConversationPreview.vue';
import IsolationParticipants from './components/IsolationParticipants.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import SpinnerLoader from 'dashboard/components-next/spinner/Spinner.vue';
import { INBOX_TYPES } from 'dashboard/helper/inbox';
import { getInboxIconByType } from 'dashboard/helper/inbox';
import Editor from 'dashboard/components-next/Editor/Editor.vue';
import ColorPicker from 'dashboard/components-next/colorpicker/ColorPicker.vue';
import SelectInput from 'dashboard/components-next/select/Select.vue';
import Banner from 'dashboard/components-next/banner/Banner.vue';
import MultiSelect from 'dashboard/components-next/filter/inputs/MultiSelect.vue';
import {
  buildIsolationTeamIdsPayload,
  normalizeTeamIds,
  teamIdsToOptions,
} from './helpers/isolationTeams';
import Widget from 'dashboard/modules/widget-preview/components/Widget.vue';
import AppearancePage from './widget/appearance/AppearancePage.vue';
import TriggersPage from './widget/triggers/TriggersPage.vue';
import TrackingPage from './widget/tracking/TrackingPage.vue';
import PreChatPage from './widget/prechat/PreChatPage.vue';
import AccessToken from 'dashboard/routes/dashboard/settings/profile/AccessToken.vue';
import { copyTextToClipboard } from 'shared/helpers/clipboard';

export default {
  components: {
    Banner,
    BotConfiguration,
    ChannelAvatarField,
    CollaboratorsPage,
    ConfigurationPage,
    MessageTemplatesPage,
    CustomerSatisfactionPage,
    NetPromoterScorePage,
    FacebookReauthorize,
    GreetingsEditor,
    PreChatFormSettings,
    SettingIntroBanner,
    SettingsToggleSection,
    SettingsFieldSection,
    SettingsAccordion,
    WeeklyAvailability,
    SenderNameExamplePreview,
    LockToSingleConversationPreview,
    IsolationParticipants,
    MicrosoftReauthorize,
    GoogleReauthorize,
    NextButton,
    SpinnerLoader,
    InstagramReauthorize,
    TiktokReauthorize,
    WhatsappReauthorize,
    DuplicateInboxBanner,
    Editor,
    ColorPicker,
    SelectInput,
    MultiSelect,
    AccountHealth,
    WhatsappManualMigrationDialog,
    WhatsappManualMigrationBanner,
    Widget,
    AccessToken,
    AppearancePage,
    TriggersPage,
    TrackingPage,
    PreChatPage,
  },
  mixins: [inboxMixin],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      avatarFile: null,
      avatarUrl: '',
      greetingEnabled: true,
      greetingMessage: '',
      emailCollectEnabled: false,
      senderNameType: 'friendly',
      businessName: '',
      locktoSingleConversation: false,
      teamMessageIsolation: false,
      agentMessageIsolation: false,
      agentConversationIsolation: false,
      // Lista VAZIA = a regra vale para todos os times (é o comportamento de hoje).
      teamMessageIsolationTeamIds: [],
      agentMessageIsolationTeamIds: [],
      agentConversationIsolationTeamIds: [],
      // Quem PARTICIPA de cada isolamento. A tela fala participantes, o banco
      // guarda exceções — a inversão acontece no controller, no submit.
      teamMessageIsolationParticipantIds: null,
      agentMessageIsolationParticipantIds: null,
      // Cópia do que está GRAVADO, para saber se a lista tem mudança pendente.
      // O botão da lista salva só a própria chave; o botão geral da tela segue
      // salvando tudo, e os dois convivem.
      savedTeamIsolationParticipantIds: null,
      savedAgentIsolationParticipantIds: null,
      savingIsolationType: null,
      isolationMembers: [],
      isolationMembersInboxId: null,
      isFetchingIsolationMembers: false,
      pendingStatusEnabled: false,
      allowMessagesAfterResolved: true,
      continuityViaEmail: true,
      selectedInboxName: '',
      channelWebsiteUrl: '',
      webhookUrl: '',
      channelWidgetColor: '',
      channelWelcomeTitle: '',
      channelWelcomeTagline: '',
      selectedFeatureFlags: [],
      replyTime: '',
      selectedTabIndex: 0,
      selectedPortalSlug: '',
      showBusinessNameInput: false,
      healthData: null,
      isLoadingHealth: false,
      healthError: null,
      isRegisteringWebhook: false,
      isTransferringWhatsAppToManual: false,
      widgetBubblePosition: 'right',
      widgetBubbleType: 'standard',
      widgetBubbleLauncherTitle: '',
      // BLOCO 3.14 — a valvula do legado, e ela e TEMPORARIA por decisao pendente.
      //
      // A aba passa a montar a Tela 3 (`PreChatPage`). O `PreChatForm/Settings.vue`
      // NAO foi apagado: o destino dele e decisao do dono (item 17 da §12 do
      // relatorio definitivo — apagar ou virar o modo Simples), e apagar antes da
      // decisao deixaria o produto sem comparacao possivel. Enquanto a decisao nao
      // vem, a tela antiga continua a UM clique, e `?prechat=legacy` na URL abre
      // direto nela para quem quiser comparar lado a lado.
      preChatLegacy: false,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
      isOnChatwootCloud: 'globalConfig/isOnChatwootCloud',
      uiFlags: 'inboxes/getUIFlags',
      portals: 'portals/allPortals',
      teams: 'teams/getTeams',
    }),
    isInboundEmailEnabled() {
      return this.isFeatureEnabledonAccount(
        this.accountId,
        FEATURE_FLAGS.INBOUND_EMAILS
      );
    },
    showContinuityToggle() {
      if (this.isInboundEmailEnabled) return true;
      return this.isOnChatwootCloud;
    },
    isContinuityDisabled() {
      return this.isOnChatwootCloud && !this.isInboundEmailEnabled;
    },
    continuityDescription() {
      if (this.isContinuityDisabled) {
        return this.$t(
          'INBOX_MGMT.SETTINGS_POPUP.ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT'
        );
      }
      return this.$t(
        'INBOX_MGMT.SETTINGS_POPUP.ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT'
      );
    },
    // Vale para as DUAS regras de mensagem: a conversa nasce sem time, antes da triagem,
    // e esconder as bolhas dela esconderia o lead novo de quem precisa atender.
    isolationNoTeamHint() {
      return this.$t(
        'INBOX_MGMT.SETTINGS_POPUP.ISOLATION_TEAMS.NO_TEAM_NEVER_ISOLATED'
      );
    },
    // O isolamento de CONVERSA é a exceção (backend: Inbox::TEAMLESS_EXEMPT_RULES não o
    // inclui). Ali o que fecha a conversa é "tem outro dono", critério que não é o time,
    // então a conversa sem time segue bloqueada. Mostrar o texto das outras duas aqui
    // faria a tela mentir sobre o que o guard aplica.
    isolationNoTeamStillIsolatedHint() {
      return this.$t(
        'INBOX_MGMT.SETTINGS_POPUP.ISOLATION_TEAMS.NO_TEAM_STILL_ISOLATED'
      );
    },
    isolationNoTeamsHint() {
      return this.$t('INBOX_MGMT.SETTINGS_POPUP.ISOLATION_TEAMS.NO_TEAMS');
    },
    isolationTeamOptions() {
      return (this.teams || []).map(team => ({
        id: team.id,
        name: team.name,
      }));
    },
    // O MultiSelect fala em objetos `{ id, name }` e a inbox fala em ids: estes três computeds são
    // a tradução, e o setter é o único ponto que escreve a lista.
    teamMessageIsolationTeams: {
      get() {
        return teamIdsToOptions(this.teamMessageIsolationTeamIds, this.teams);
      },
      set(value) {
        this.teamMessageIsolationTeamIds = normalizeTeamIds(value);
      },
    },
    agentMessageIsolationTeams: {
      get() {
        return teamIdsToOptions(this.agentMessageIsolationTeamIds, this.teams);
      },
      set(value) {
        this.agentMessageIsolationTeamIds = normalizeTeamIds(value);
      },
    },
    agentConversationIsolationTeams: {
      get() {
        return teamIdsToOptions(
          this.agentConversationIsolationTeamIds,
          this.teams
        );
      },
      set(value) {
        this.agentConversationIsolationTeamIds = normalizeTeamIds(value);
      },
    },
    selectedTabKey() {
      const key = this.tabs[this.selectedTabIndex]?.key;
      return key;
    },
    shouldShowWhatsAppConfiguration() {
      return this.isAWhatsAppCloudChannel;
    },
    whatsAppAPIProviderName() {
      if (this.isAWhatsAppCloudChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.WHATSAPP_CLOUD');
      }
      if (this.is360DialogWhatsAppChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.360_DIALOG');
      }
      if (this.isATwilioWhatsAppChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.TWILIO');
      }
      return '';
    },
    tabs() {
      let visibleToAllChannelTabs = [
        {
          key: 'inbox-settings',
          name: this.$t('INBOX_MGMT.TABS.SETTINGS'),
        },
        {
          key: 'collaborators',
          name: this.$t('INBOX_MGMT.TABS.COLLABORATORS'),
        },
      ];

      if (!this.isAVoiceChannel) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'business-hours',
            name: this.$t('INBOX_MGMT.TABS.BUSINESS_HOURS'),
          },
          {
            key: 'csat',
            name: this.$t('INBOX_MGMT.TABS.CSAT'),
          },
          {
            key: 'nps',
            name: this.$t('INBOX_MGMT.TABS.NPS'),
          },
        ];
      }

      if (this.isAWebWidgetInbox) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'appearance',
            name: this.$t('INBOX_WIDGET.TABS.APPEARANCE'),
          },
          {
            key: 'triggers',
            name: this.$t('INBOX_WIDGET.TRIGGERS.TAB'),
          },
          {
            key: 'tracking',
            name: this.$t('INBOX_WIDGET.TRACKING.TAB'),
          },
          {
            key: 'pre-chat-form',
            name: this.$t('INBOX_MGMT.TABS.PRE_CHAT_FORM'),
          },
        ];
      }

      if (
        this.isATwilioChannel ||
        this.isALineChannel ||
        this.isAPIInbox ||
        this.isAVoiceChannel ||
        (this.isAnEmailChannel && !this.inbox.provider) ||
        this.shouldShowWhatsAppConfiguration ||
        this.isAWebWidgetInbox
      ) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'configuration',
            name: this.$t('INBOX_MGMT.TABS.CONFIGURATION'),
          },
        ];
      }

      if (
        this.isFeatureEnabledonAccount(this.accountId, FEATURE_FLAGS.AGENT_BOTS)
      ) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'bot-configuration',
            name: this.$t('INBOX_MGMT.TABS.BOT_CONFIGURATION'),
          },
        ];
      }
      if (this.shouldShowWhatsAppConfiguration) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'whatsapp-health',
            name: this.$t('INBOX_MGMT.TABS.ACCOUNT_HEALTH'),
          },
          {
            key: 'message-templates',
            name: this.$t('INBOX_MGMT.TABS.MESSAGE_TEMPLATES'),
          },
        ];
      }

      return visibleToAllChannelTabs;
    },
    currentInboxId() {
      return Number(this.$route.params.inboxId);
    },
    inbox() {
      return this.$store.getters['inboxes/getInbox'](this.currentInboxId);
    },
    inboxIcon() {
      const { medium, channel_type: type } = this.inbox;
      return getInboxIconByType(type, medium, 'line');
    },
    bannerMaxWidth() {
      const narrowTabs = ['collaborators', 'bot-configuration'];
      const wideIfWebWidget = ['configuration', 'inbox-settings'];
      if (narrowTabs.includes(this.selectedTabKey)) return 'max-w-4xl';
      if (wideIfWebWidget.includes(this.selectedTabKey)) {
        return this.isAWebWidgetInbox ? 'max-w-7xl' : 'max-w-4xl';
      }
      return 'max-w-7xl';
    },
    inboxName() {
      if (this.isATwilioSMSChannel || this.isATwilioWhatsAppChannel) {
        return `${this.inbox.name} (${
          this.inbox.messaging_service_sid || this.inbox.phone_number
        })`;
      }
      if (this.isAWhatsAppChannel) {
        return `${this.inbox.name} (${this.inbox.phone_number})`;
      }
      if (this.isAnEmailChannel) {
        return `${this.inbox.name} (${this.inbox.email})`;
      }
      return this.inbox.name;
    },
    canLocktoSingleConversation() {
      return (
        this.isASmsInbox ||
        this.isAWhatsAppChannel ||
        this.isAFacebookInbox ||
        this.isAPIInbox ||
        this.isAnInstagramChannel ||
        this.isALineChannel ||
        this.isATiktokChannel ||
        this.isATelegramChannel
      );
    },
    // A lista de agentes é a novidade dos cards de isolamento: só existe com o
    // toggle ligado, então com os dois desligados a tela fica igual à de hoje.
    showIsolationParticipants() {
      return this.teamMessageIsolation || this.agentMessageIsolation;
    },
    isTeamIsolationListDirty() {
      return this.isolationListChanged(
        this.teamMessageIsolationParticipantIds,
        this.savedTeamIsolationParticipantIds
      );
    },
    isAgentIsolationListDirty() {
      return this.isolationListChanged(
        this.agentMessageIsolationParticipantIds,
        this.savedAgentIsolationParticipantIds
      );
    },
    inboxNameLabel() {
      if (this.isAWebWidgetInbox) {
        return this.$t('INBOX_MGMT.ADD.WEBSITE_NAME.LABEL');
      }
      return this.$t('INBOX_MGMT.ADD.CHANNEL_NAME.LABEL');
    },
    inboxNamePlaceHolder() {
      if (this.isAWebWidgetInbox) {
        return this.$t('INBOX_MGMT.ADD.WEBSITE_NAME.PLACEHOLDER');
      }
      return this.$t('INBOX_MGMT.ADD.CHANNEL_NAME.PLACEHOLDER');
    },
    textAreaChannels() {
      if (
        this.isATwilioChannel ||
        this.isATwitterInbox ||
        this.isAFacebookInbox
      )
        return true;
      return false;
    },
    instagramUnauthorized() {
      return this.isAnInstagramChannel && this.inbox.reauthorization_required;
    },
    tiktokUnauthorized() {
      return this.isATiktokChannel && this.inbox.reauthorization_required;
    },
    // Check if a instagram inbox exists with the same instagram_id
    hasDuplicateInstagramInbox() {
      const instagramId = this.inbox.instagram_id;
      const instagramInbox =
        this.$store.getters['inboxes/getInstagramInboxByInstagramId'](
          instagramId
        );

      return this.inbox.channel_type === INBOX_TYPES.FB && instagramInbox;
    },
    microsoftUnauthorized() {
      return this.isAMicrosoftInbox && this.inbox.reauthorization_required;
    },
    facebookUnauthorized() {
      return this.isAFacebookInbox && this.inbox.reauthorization_required;
    },
    googleUnauthorized() {
      const isLegacyInbox = ['imap.gmail.com', 'imap.google.com'].includes(
        this.inbox.imap_address
      );

      return (
        (this.isAGoogleInbox || isLegacyInbox) &&
        this.inbox.reauthorization_required
      );
    },
    isEmbeddedSignupWhatsApp() {
      return this.inbox.provider_config?.source === 'embedded_signup';
    },
    whatsappUnauthorized() {
      return (
        this.isAWhatsAppCloudChannel &&
        this.isEmbeddedSignupWhatsApp &&
        (!this.isOnChatwootCloud ||
          this.isFeatureEnabledonAccount(
            this.accountId,
            FEATURE_FLAGS.WHATSAPP_EMBEDDED_SIGNUP_FLOW
          )) &&
        this.inbox.reauthorization_required
      );
    },
    whatsappRegistrationIncomplete() {
      if (
        !this.healthData ||
        !this.isAWhatsAppCloudChannel ||
        !this.isEmbeddedSignupWhatsApp
      ) {
        return false;
      }

      return (
        this.healthData.platform_type === 'NOT_APPLICABLE' ||
        this.healthData.throughput?.level === 'NOT_APPLICABLE'
      );
    },
    showWhatsAppManualMigration() {
      return (
        this.isAWhatsAppCloudChannel &&
        this.isEmbeddedSignupWhatsApp &&
        this.healthError?.type !== 'authorization' &&
        this.isFeatureEnabledonAccount(
          this.accountId,
          FEATURE_FLAGS.WHATSAPP_MANUAL_TRANSFER
        )
      );
    },
    // Bloco 3.18: a aparencia mora no banco, nao no localStorage deste navegador (defeito D1).
    // O objeto gravado e devolvido inteiro por `_inbox.json.jbuilder:27`.
    storedWidgetAppearance() {
      return this.inbox?.additional_attributes?.widget_appearance || {};
    },
  },
  watch: {
    $route(to, from) {
      if (to.name === 'settings_inbox_show') {
        const inboxChanged = to.params.inboxId !== from.params.inboxId;
        if (inboxChanged) {
          this.syncInboxData();
          this.setTabFromRouteParam();
          this.openWhatsAppManualMigrationIfRequested();
        }
      }
    },
    teamMessageIsolation() {
      this.fetchIsolationMembers();
    },
    agentMessageIsolation() {
      this.fetchIsolationMembers();
    },
    inbox: {
      handler(newInbox, oldInbox) {
        if (newInbox?.id !== oldInbox?.id) {
          this.syncInboxData();
          this.fetchHealthData();
          this.$nextTick(() => {
            this.setTabFromRouteParam();
            this.openWhatsAppManualMigrationIfRequested();
          });
        } else {
          this.selectedFeatureFlags = newInbox?.selected_feature_flags || [];
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.fetchSharedData();
    this.openWhatsAppManualMigrationIfRequested();
  },
  methods: {
    openWhatsAppManualMigrationDialog() {
      this.$refs.whatsappManualMigrationDialog?.open();
    },
    openWhatsAppManualMigrationIfRequested() {
      if (
        this.showWhatsAppManualMigration &&
        this.$route.query.migration === 'whatsapp_manual'
      ) {
        this.$nextTick(() => {
          this.openWhatsAppManualMigrationDialog();
        });
      }
    },
    async transferWhatsAppToManualSetup(form) {
      this.isTransferringWhatsAppToManual = true;
      try {
        const providerConfig = { ...(this.inbox.provider_config || {}) };
        delete providerConfig.source;
        const payload = {
          id: this.inbox.id,
          formData: false,
          channel: {
            provider_config: {
              ...providerConfig,
              phone_number_id: form.phoneNumberId,
              business_account_id: form.wabaId,
              api_key: form.accessToken,
            },
          },
        };
        await this.$store.dispatch('inboxes/updateInbox', payload);
        useAlert(
          this.$t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_MANUAL_TRANSFER_SUCCESS')
        );
        this.$refs.whatsappManualMigrationDialog?.close();
      } catch (error) {
        useAlert(
          this.$t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_MANUAL_TRANSFER_ERROR')
        );
      } finally {
        this.isTransferringWhatsAppToManual = false;
      }
    },
    async copyWebhookSecret(value) {
      await copyTextToClipboard(value);
      useAlert(
        this.$t(
          'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_SECRET.COPY_SUCCESS'
        )
      );
    },
    async resetWebhookSecret() {
      const response = await this.$store.dispatch(
        'inboxes/resetSecret',
        this.inbox.id
      );
      if (response) {
        useAlert(
          this.$t(
            'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_SECRET.RESET_SUCCESS'
          )
        );
      } else {
        useAlert(
          this.$t(
            'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_SECRET.RESET_ERROR'
          )
        );
      }
    },
    fetchSharedData() {
      this.$store.dispatch('agents/get');
      this.$store.dispatch('teams/get');
      this.$store.dispatch('labels/get');
      this.$store.dispatch('portals/index');
    },
    syncInboxData() {
      if (!this.inbox || !this.inbox.id) return;

      this.avatarUrl = this.inbox.avatar_url;
      this.selectedInboxName = this.inbox.name;
      this.webhookUrl = this.inbox.webhook_url;
      this.greetingEnabled = this.inbox.greeting_enabled || false;
      this.greetingMessage = this.inbox.greeting_message || '';
      this.emailCollectEnabled = this.inbox.enable_email_collect;
      this.senderNameType = this.inbox.sender_name_type;
      this.businessName = this.inbox.business_name;
      this.allowMessagesAfterResolved =
        this.inbox.allow_messages_after_resolved;
      this.continuityViaEmail = this.inbox.continuity_via_email;
      this.channelWebsiteUrl = this.inbox.website_url;
      this.channelWidgetColor = this.inbox.widget_color;
      this.channelWelcomeTitle = this.inbox.welcome_title;
      this.channelWelcomeTagline = this.inbox.welcome_tagline || '';
      this.selectedFeatureFlags = this.inbox.selected_feature_flags || [];
      this.replyTime = this.inbox.reply_time;
      this.locktoSingleConversation = this.inbox.lock_to_single_conversation;
      this.teamMessageIsolation = this.inbox.team_message_isolation || false;
      this.agentMessageIsolation = this.inbox.agent_message_isolation || false;
      this.agentConversationIsolation =
        this.inbox.agent_conversation_isolation || false;
      this.teamMessageIsolationTeamIds = normalizeTeamIds(
        this.inbox.team_message_isolation_team_ids
      );
      this.agentMessageIsolationTeamIds = normalizeTeamIds(
        this.inbox.agent_message_isolation_team_ids
      );
      this.agentConversationIsolationTeamIds = normalizeTeamIds(
        this.inbox.agent_conversation_isolation_team_ids
      );
      // `null` (e não `[]`) quando a caixa não trouxe as listas: um payload antigo
      // em cache não pode virar "isenta todo mundo" no primeiro salvamento.
      this.teamMessageIsolationParticipantIds =
        this.inbox.team_message_isolation_participant_ids ?? null;
      this.agentMessageIsolationParticipantIds =
        this.inbox.agent_message_isolation_participant_ids ?? null;
      this.savedTeamIsolationParticipantIds = this.cloneIds(
        this.teamMessageIsolationParticipantIds
      );
      this.savedAgentIsolationParticipantIds = this.cloneIds(
        this.agentMessageIsolationParticipantIds
      );
      this.isolationMembers = [];
      this.isolationMembersInboxId = null;
      this.fetchIsolationMembers();
      this.pendingStatusEnabled = this.inbox.pending_status_enabled || false;
      this.selectedPortalSlug = this.inbox.help_center
        ? this.inbox.help_center.slug
        : '';

      const appearance = this.storedWidgetAppearance;
      this.widgetBubblePosition = appearance.position || 'right';
      this.widgetBubbleType = appearance.launcher_type || 'standard';
      this.widgetBubbleLauncherTitle = appearance.launcher_text || '';
    },
    // A lista de agentes só é buscada quando algum isolamento está ligado: com os
    // dois desligados nenhuma lista aparece e a requisição seria desperdício.
    // `isolationMembersInboxId` guarda a caixa já pedida (ou em voo), então
    // trocar de caixa refaz a busca e uma resposta atrasada da caixa anterior é
    // descartada em vez de virar a lista errada na tela.
    async fetchIsolationMembers() {
      const inboxId = this.currentInboxId;
      if (!inboxId || !this.showIsolationParticipants) return;
      if (this.isolationMembersInboxId === inboxId) return;

      this.isolationMembersInboxId = inboxId;
      this.isFetchingIsolationMembers = true;
      try {
        const response = await this.$store.dispatch('inboxMembers/get', {
          inboxId,
        });
        if (this.currentInboxId !== inboxId) return;
        this.isolationMembers = response?.data?.payload || [];
      } catch (error) {
        if (this.isolationMembersInboxId === inboxId) {
          this.isolationMembersInboxId = null;
        }
      } finally {
        if (this.currentInboxId === inboxId) {
          this.isFetchingIsolationMembers = false;
        }
      }
    },
    async fetchHealthData() {
      if (!this.inbox) return;

      if (!this.isAWhatsAppCloudChannel) {
        return;
      }

      try {
        this.isLoadingHealth = true;
        this.healthError = null;
        const response = await InboxHealthAPI.getHealthStatus(this.inbox.id);
        this.healthData = response.data;
      } catch (error) {
        const apiError = error.response?.data?.error;
        this.healthError =
          typeof apiError === 'object'
            ? apiError
            : {
                type: 'generic',
                message: apiError || error.message,
              };
      } finally {
        this.isLoadingHealth = false;
      }
    },
    goToWhatsAppConfiguration() {
      const configurationTabIndex = this.tabs.findIndex(
        tab => tab.key === 'configuration'
      );
      if (configurationTabIndex !== -1) {
        this.onTabChange(configurationTabIndex);
      }
    },
    async registerWebhook() {
      if (!this.inbox) return;

      try {
        this.isRegisteringWebhook = true;
        await InboxHealthAPI.registerWebhook(this.inbox.id);
        useAlert(this.$t('INBOX_MGMT.ACCOUNT_HEALTH.WEBHOOK.REGISTER_SUCCESS'));
        await this.fetchHealthData();
      } catch (error) {
        useAlert(
          error.message ||
            this.$t('INBOX_MGMT.ACCOUNT_HEALTH.WEBHOOK.REGISTER_ERROR')
        );
      } finally {
        this.isRegisteringWebhook = false;
      }
    },
    // Vazio não é "nenhum time": a linha embaixo do seletor tem que dizer isso, senão o admin
    // acha que a regra está desligada quando ela está valendo para a caixa inteira.
    isolationScopeHint(teamIds) {
      return teamIds.length
        ? this.$t('INBOX_MGMT.SETTINGS_POPUP.ISOLATION_TEAMS.SCOPED')
        : this.$t('INBOX_MGMT.SETTINGS_POPUP.ISOLATION_TEAMS.ALL_TEAMS');
    },
    handleFeatureFlag(e) {
      this.selectedFeatureFlags = this.toggleInput(
        this.selectedFeatureFlags,
        e.target.value
      );
    },
    toggleInput(selected, current) {
      if (selected.includes(current)) {
        const newSelectedFlags = selected.filter(flag => flag !== current);
        return newSelectedFlags;
      }
      return [...selected, current];
    },
    onTabChange(selectedTabIndex) {
      // A troca de aba NÃO passa pelo router (a URL muda por
      // `history.replaceState`), então nenhum guard de rota a vê. A tela de
      // aparência mantém rascunho: perguntar antes é o que impede o
      // administrador de perder dez campos configurados num clique.
      // Só UMA das telas de rascunho está montada por vez (cada uma tem o seu
      // `v-if`), então a primeira que responder é a que está na tela.
      const comRascunho = [
        this.$refs.appearancePage,
        this.$refs.triggersPage,
        this.$refs.trackingPage,
        this.$refs.preChatPage,
      ];
      const atual = comRascunho.find(tela => tela?.requestLeave);
      if (
        atual &&
        !atual.requestLeave(() => this.applyTabChange(selectedTabIndex))
      ) {
        return;
      }
      this.applyTabChange(selectedTabIndex);
    },
    // A troca entre a Tela 3 e a tela antiga descarta o rascunho da Tela 3, e
    // por isso passa pelo mesmo guarda da troca de aba: sem ele, um clique de
    // curiosidade jogaria fora oito campos configurados sem perguntar.
    togglePreChatLegacy() {
      const tela = this.$refs.preChatPage;
      const trocar = () => {
        this.preChatLegacy = !this.preChatLegacy;
      };
      // `requestLeave` ja executa a acao sozinho quando nao ha pendencia, e a
      // segura no dialogo quando ha. Voltando do legado a Tela 3 nem esta
      // montada, e ai a troca e direta.
      if (tela?.requestLeave) tela.requestLeave(trocar);
      else trocar();
    },
    applyTabChange(selectedTabIndex) {
      this.selectedTabIndex = selectedTabIndex;
      this.updateRouteWithoutRefresh(selectedTabIndex);
    },
    updateRouteWithoutRefresh(selectedTabIndex) {
      const tab = this.tabs[selectedTabIndex];
      if (!tab) return;

      const { accountId, inboxId } = this.$route.params;
      const baseUrl = `/app/accounts/${accountId}/settings/inboxes/${inboxId}`;

      // Append the tab key only if it's not the default.
      const newUrl =
        tab.key === 'inbox-settings' ? baseUrl : `${baseUrl}/${tab.key}`;
      // Update URL without triggering route watcher
      window.history.replaceState(null, '', newUrl);
    },
    setTabFromRouteParam() {
      // `?prechat=legacy` abre a aba direto na tela antiga (bloco 3.14).
      this.preChatLegacy = this.$route.query.prechat === 'legacy';
      const { tab: tabParam } = this.$route.params;
      if (!tabParam) {
        this.selectedTabIndex = 0;
        return;
      }
      const tabIndex = this.tabs.findIndex(tab => tab.key === tabParam);
      this.selectedTabIndex = tabIndex === -1 ? 0 : tabIndex;
    },
    cloneIds(ids) {
      return Array.isArray(ids) ? [...ids] : null;
    },
    // Compara ignorando a ordem: marcar e desmarcar o mesmo agente não deve
    // deixar o botão aceso.
    isolationListChanged(atual, salvo) {
      if (atual === null || salvo === null) return atual !== salvo;
      if (atual.length !== salvo.length) return true;
      const a = [...atual].sort();
      const b = [...salvo].sort();
      return a.some((id, i) => id !== b[i]);
    },
    // Salva SÓ a lista daquele card. O controller ignora as chaves que não vêm
    // no PATCH, então nada mais da caixa é tocado.
    async saveIsolationParticipants(isolationType) {
      const isTeam = isolationType === 'team_message';
      const ids = isTeam
        ? this.teamMessageIsolationParticipantIds
        : this.agentMessageIsolationParticipantIds;
      if (ids === null) return;

      this.savingIsolationType = isolationType;
      try {
        await this.$store.dispatch('inboxes/updateInbox', {
          id: this.currentInboxId,
          [`${isolationType}_isolation_participant_ids`]: ids,
        });
        if (isTeam) {
          this.savedTeamIsolationParticipantIds = this.cloneIds(ids);
        } else {
          this.savedAgentIsolationParticipantIds = this.cloneIds(ids);
        }
        useAlert(
          this.$t('INBOX_MGMT.SETTINGS_POPUP.ISOLATION_PARTICIPANTS.SAVED')
        );
      } catch (error) {
        useAlert(
          this.$t('INBOX_MGMT.SETTINGS_POPUP.ISOLATION_PARTICIPANTS.SAVE_ERROR')
        );
      } finally {
        this.savingIsolationType = null;
      }
    },
    async updateInbox() {
      try {
        this.$nextTick(() => {
          this.setTabFromRouteParam();
        });
        const payload = {
          id: this.currentInboxId,
          name: this.selectedInboxName?.trim(),
          enable_email_collect: this.emailCollectEnabled,
          allow_messages_after_resolved: this.allowMessagesAfterResolved,
          greeting_enabled: this.greetingEnabled,
          greeting_message: this.greetingMessage || '',
          portal_id: this.selectedPortalSlug
            ? this.portals.find(
                portal => portal.slug === this.selectedPortalSlug
              )?.id || null
            : null,
          lock_to_single_conversation: this.locktoSingleConversation,
          team_message_isolation: this.teamMessageIsolation,
          agent_message_isolation: this.agentMessageIsolation,
          agent_conversation_isolation: this.agentConversationIsolation,
          // Espalhado (e não escrito chave a chave) de propósito: quando a inbox não trouxe a
          // lista, a chave NÃO entra no payload. Mandar `[]` de um campo que a tela nunca recebeu
          // apagaria o escopo de quem já tinha configurado.
          ...buildIsolationTeamIdsPayload(this.inbox, {
            team_message_isolation_team_ids: this.teamMessageIsolationTeamIds,
            agent_message_isolation_team_ids: this.agentMessageIsolationTeamIds,
            agent_conversation_isolation_team_ids:
              this.agentConversationIsolationTeamIds,
          }),
          pending_status_enabled: this.pendingStatusEnabled,
          sender_name_type: this.senderNameType,
          business_name: this.businessName || null,
          // O merge do servidor e raso no primeiro nivel (`inboxes_controller.rb:52-56`): mandar
          // apenas os tres campos desta tela apagaria os que ela ainda nao edita (tema, offsets,
          // icone). Por isso o objeto vai INTEIRO, com o que ja estava gravado por baixo.
          ...(this.isAWebWidgetInbox
            ? {
                additional_attributes: {
                  widget_appearance: {
                    ...this.storedWidgetAppearance,
                    position: this.widgetBubblePosition,
                    launcher_type: this.widgetBubbleType,
                    launcher_text: this.widgetBubbleLauncherTitle || '',
                  },
                },
              }
            : {}),
          channel: {
            widget_color: this.channelWidgetColor,
            website_url: this.channelWebsiteUrl,
            webhook_url: this.webhookUrl,
            welcome_title: this.channelWelcomeTitle || '',
            welcome_tagline: this.channelWelcomeTagline || '',
            selectedFeatureFlags: this.selectedFeatureFlags,
            reply_time: this.replyTime || 'in_a_few_minutes',
            continuity_via_email:
              this.isInboundEmailEnabled && this.continuityViaEmail,
          },
        };
        // Participantes só sobem com o isolamento LIGADO. Chave ausente não mexe
        // em exceção nenhuma (é o contrato do controller), então desligar o
        // toggle preserva o que já estava marcado em vez de apagar calado.
        if (
          this.teamMessageIsolation &&
          this.teamMessageIsolationParticipantIds
        ) {
          payload.team_message_isolation_participant_ids =
            this.teamMessageIsolationParticipantIds;
        }
        if (
          this.agentMessageIsolation &&
          this.agentMessageIsolationParticipantIds
        ) {
          payload.agent_message_isolation_participant_ids =
            this.agentMessageIsolationParticipantIds;
        }
        if (this.avatarFile) {
          payload.avatar = this.avatarFile;
        }
        await this.$store.dispatch('inboxes/updateInbox', payload);
        useAlert(this.$t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
        this.showBusinessNameInput = false;
      } catch (error) {
        useAlert(error.message || this.$t('INBOX_MGMT.EDIT.API.ERROR_MESSAGE'));
      }
    },
    handleImageUpload({ file, url }) {
      this.avatarFile = file;
      this.avatarUrl = url;
    },
    async handleAvatarDelete() {
      try {
        await this.$store.dispatch(
          'inboxes/deleteInboxAvatar',
          this.currentInboxId
        );
        this.avatarFile = null;
        this.avatarUrl = '';
        useAlert(this.$t('INBOX_MGMT.DELETE.API.AVATAR_SUCCESS_MESSAGE'));
      } catch (error) {
        useAlert(
          error.message
            ? error.message
            : this.$t('INBOX_MGMT.DELETE.API.AVATAR_ERROR_MESSAGE')
        );
      }
    },
    toggleSenderNameType(key) {
      this.senderNameType = key;
    },
    onClickShowBusinessNameInput() {
      this.showBusinessNameInput = true;
      this.$nextTick(() => {
        this.$refs.businessNameInput?.focus();
      });
    },
    hideBusinessNameInput() {
      this.showBusinessNameInput = false;
    },
    toggleLockToSingleConversation(value) {
      this.locktoSingleConversation = value;
    },
  },
  validations: {
    webhookUrl: {
      shouldBeUrl,
    },
    selectedInboxName: {},
  },
};
</script>

<template>
  <div
    v-if="uiFlags.isFetching"
    class="flex items-center justify-center h-full w-full"
  >
    <SpinnerLoader :size="28" class="text-n-blue-9" />
  </div>
  <div
    v-else
    class="grid grid-rows-[auto_1fr] grid-cols-[minmax(0,1fr)] h-full flex-grow flex-shrink pr-0 pl-0 w-full min-w-0 overflow-x-hidden settings"
  >
    <SettingIntroBanner
      :header-image="inbox.avatarUrl"
      :header-title="inboxName"
    >
      <div class="w-full overflow-x-auto overflow-y-hidden">
        <woot-tabs
          class="[&_ul]:p-0 top-px relative [&_ul]:flex-nowrap [&_ul]:w-max"
          :index="selectedTabIndex"
          :border="false"
          @change="onTabChange"
        >
          <woot-tabs-item
            v-for="(tab, index) in tabs"
            :key="tab.key"
            :index="index"
            :name="tab.name"
            :show-badge="false"
            is-compact
          />
        </woot-tabs>
      </div>
    </SettingIntroBanner>
    <section class="w-full overflow-auto py-8">
      <div class="max-w-7xl mx-auto w-full">
        <MicrosoftReauthorize
          v-if="microsoftUnauthorized"
          :inbox="inbox"
          class="mb-4"
          :class="bannerMaxWidth"
        />
        <FacebookReauthorize
          v-if="facebookUnauthorized"
          :inbox="inbox"
          class="mb-4"
          :class="bannerMaxWidth"
        />
        <GoogleReauthorize
          v-if="googleUnauthorized"
          :inbox="inbox"
          class="mb-4"
          :class="bannerMaxWidth"
        />
        <InstagramReauthorize
          v-if="instagramUnauthorized"
          :inbox="inbox"
          class="mb-4"
          :class="bannerMaxWidth"
        />
        <TiktokReauthorize
          v-if="tiktokUnauthorized"
          :inbox="inbox"
          class="mb-4"
          :class="bannerMaxWidth"
        />
        <WhatsappReauthorize
          v-if="whatsappUnauthorized"
          :whatsapp-registration-incomplete="whatsappRegistrationIncomplete"
          :inbox="inbox"
          class="mb-4"
          :class="bannerMaxWidth"
        />
        <DuplicateInboxBanner
          v-if="hasDuplicateInstagramInbox"
          :content="$t('INBOX_MGMT.ADD.INSTAGRAM.DUPLICATE_INBOX_BANNER')"
          class="mx-6 mb-4"
          :class="bannerMaxWidth"
        />
        <WhatsappManualMigrationBanner
          v-if="showWhatsAppManualMigration"
          class="mx-6 mb-6"
          :class="bannerMaxWidth"
          @start="openWhatsAppManualMigrationDialog"
        />

        <div
          v-if="selectedTabKey === 'inbox-settings'"
          class="flex flex-col md:flex-row items-center lg:items-start justify-between gap-5 lg:gap-10 mx-6"
        >
          <div
            class="flex-1 flex flex-col min-w-0"
            :class="{
              'max-w-2xl': isAWebWidgetInbox,
              'max-w-4xl': !isAWebWidgetInbox,
            }"
          >
            <ChannelAvatarField
              class="mb-4"
              :src="avatarUrl"
              :icon-name="inboxIcon"
              name=""
              :show-placement-hint="isAWebWidgetInbox"
              @upload="handleImageUpload"
              @delete="handleAvatarDelete"
            />
            <SettingsFieldSection :label="inboxNameLabel">
              <woot-input
                v-model="selectedInboxName"
                class="[&>input]:!mb-0"
                :class="{ error: v$.selectedInboxName.$error }"
                :placeholder="inboxNamePlaceHolder"
                :error="
                  v$.selectedInboxName.$error
                    ? $t('INBOX_MGMT.ADD.CHANNEL_NAME.ERROR')
                    : ''
                "
                @blur="v$.selectedInboxName.$touch"
              />
            </SettingsFieldSection>
            <SettingsFieldSection
              v-if="isAPIInbox"
              :label="
                $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_URL.LABEL')
              "
            >
              <woot-input
                v-model="webhookUrl"
                class="[&>input]:!mb-0"
                :class="{ error: v$.webhookUrl.$error }"
                :placeholder="
                  $t(
                    'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_URL.PLACEHOLDER'
                  )
                "
                :error="
                  v$.webhookUrl.$error
                    ? $t(
                        'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_URL.ERROR'
                      )
                    : ''
                "
                @blur="v$.webhookUrl.$touch"
              />
            </SettingsFieldSection>

            <SettingsFieldSection
              v-if="isAPIInbox && inbox.secret"
              :label="
                $t(
                  'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_SECRET.LABEL'
                )
              "
            >
              <AccessToken
                :value="inbox.secret"
                @on-copy="copyWebhookSecret"
                @on-reset="resetWebhookSecret"
              />
            </SettingsFieldSection>

            <SettingsFieldSection
              v-if="isAWebWidgetInbox"
              :label="$t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_DOMAIN.LABEL')"
            >
              <woot-input
                v-model="channelWebsiteUrl"
                class="[&>input]:!mb-0"
                :placeholder="
                  $t(
                    'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_DOMAIN.PLACEHOLDER'
                  )
                "
              />
            </SettingsFieldSection>

            <SettingsFieldSection
              v-if="isAWhatsAppChannel"
              :label="$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.LABEL')"
            >
              <input
                v-model="whatsAppAPIProviderName"
                type="text"
                disabled
                class="!mb-0"
              />
            </SettingsFieldSection>

            <SettingsFieldSection
              v-if="!isAVoiceChannel"
              :label="$t('INBOX_MGMT.HELP_CENTER.LABEL')"
              :help-text="$t('INBOX_MGMT.HELP_CENTER.SUB_TEXT')"
            >
              <SelectInput
                v-model="selectedPortalSlug"
                :placeholder="$t('INBOX_MGMT.HELP_CENTER.PLACEHOLDER')"
                :options="[
                  { value: '', label: $t('INBOX_MGMT.HELP_CENTER.NONE') },
                  ...portals.map(p => ({ value: p.slug, label: p.name })),
                ]"
              />
            </SettingsFieldSection>

            <SettingsFieldSection
              v-if="canLocktoSingleConversation"
              :label="
                $t('INBOX_MGMT.SETTINGS_POPUP.LOCK_TO_SINGLE_CONVERSATION')
              "
              class="[&>div>div]:justify-end [&>div>div]:flex lg:[&>div:first-child]:h-12 [&>div:first-child]:h-16"
            >
              <template #extra>
                <LockToSingleConversationPreview
                  :lock-to-single-conversation="locktoSingleConversation"
                  @update="toggleLockToSingleConversation"
                />
              </template>
            </SettingsFieldSection>

            <SettingsToggleSection
              v-model="teamMessageIsolation"
              :header="$t('INBOX_MGMT.SETTINGS_POPUP.TEAM_MESSAGE_ISOLATION')"
              :description="
                $t('INBOX_MGMT.SETTINGS_POPUP.TEAM_MESSAGE_ISOLATION_SUB_TEXT')
              "
              class="mb-4"
            >
              <!-- O slot vive num <template v-if>: regra desligada não tem escopo para
                   escolher, e o seletor sumindo junto com o interruptor deixa isso óbvio. -->
              <template v-if="teamMessageIsolation" #editor>
                <div class="flex flex-col items-start gap-2">
                  <span class="text-sm font-medium text-n-slate-12">
                    {{ $t('INBOX_MGMT.SETTINGS_POPUP.ISOLATION_TEAMS.LABEL') }}
                  </span>
                  <MultiSelect
                    v-model="teamMessageIsolationTeams"
                    :options="isolationTeamOptions"
                  />
                  <p class="mb-0 text-sm text-n-slate-11">
                    {{ isolationScopeHint(teamMessageIsolationTeamIds) }}
                  </p>
                  <p class="mb-0 text-sm text-n-slate-10">
                    {{ isolationNoTeamHint }}
                  </p>
                  <p
                    v-if="!isolationTeamOptions.length"
                    class="mb-0 text-sm text-n-slate-10"
                  >
                    {{ isolationNoTeamsHint }}
                  </p>
                </div>
                <IsolationParticipants
                  v-model="teamMessageIsolationParticipantIds"
                  isolation-type="team_message"
                  :agents="isolationMembers"
                  :is-loading="isFetchingIsolationMembers"
                  :is-dirty="isTeamIsolationListDirty"
                  :is-saving="savingIsolationType === 'team_message'"
                  @save="saveIsolationParticipants('team_message')"
                />
              </template>
            </SettingsToggleSection>

            <SettingsToggleSection
              v-model="agentMessageIsolation"
              :header="$t('INBOX_MGMT.SETTINGS_POPUP.AGENT_MESSAGE_ISOLATION')"
              :description="
                $t('INBOX_MGMT.SETTINGS_POPUP.AGENT_MESSAGE_ISOLATION_SUB_TEXT')
              "
              class="mb-4"
            >
              <template v-if="agentMessageIsolation" #editor>
                <div class="flex flex-col items-start gap-2">
                  <span class="text-sm font-medium text-n-slate-12">
                    {{ $t('INBOX_MGMT.SETTINGS_POPUP.ISOLATION_TEAMS.LABEL') }}
                  </span>
                  <MultiSelect
                    v-model="agentMessageIsolationTeams"
                    :options="isolationTeamOptions"
                  />
                  <p class="mb-0 text-sm text-n-slate-11">
                    {{ isolationScopeHint(agentMessageIsolationTeamIds) }}
                  </p>
                  <p class="mb-0 text-sm text-n-slate-10">
                    {{ isolationNoTeamHint }}
                  </p>
                  <p
                    v-if="!isolationTeamOptions.length"
                    class="mb-0 text-sm text-n-slate-10"
                  >
                    {{ isolationNoTeamsHint }}
                  </p>
                </div>
                <IsolationParticipants
                  v-model="agentMessageIsolationParticipantIds"
                  isolation-type="agent_message"
                  :agents="isolationMembers"
                  :is-loading="isFetchingIsolationMembers"
                  :is-dirty="isAgentIsolationListDirty"
                  :is-saving="savingIsolationType === 'agent_message'"
                  @save="saveIsolationParticipants('agent_message')"
                />
              </template>
            </SettingsToggleSection>

            <SettingsToggleSection
              v-model="agentConversationIsolation"
              :header="
                $t('INBOX_MGMT.SETTINGS_POPUP.AGENT_CONVERSATION_ISOLATION')
              "
              :description="
                $t(
                  'INBOX_MGMT.SETTINGS_POPUP.AGENT_CONVERSATION_ISOLATION_SUB_TEXT'
                )
              "
              class="mb-4"
            >
              <template v-if="agentConversationIsolation" #editor>
                <div class="flex flex-col items-start gap-2">
                  <span class="text-sm font-medium text-n-slate-12">
                    {{ $t('INBOX_MGMT.SETTINGS_POPUP.ISOLATION_TEAMS.LABEL') }}
                  </span>
                  <MultiSelect
                    v-model="agentConversationIsolationTeams"
                    :options="isolationTeamOptions"
                  />
                  <p class="mb-0 text-sm text-n-slate-11">
                    {{ isolationScopeHint(agentConversationIsolationTeamIds) }}
                  </p>
                  <p class="mb-0 text-sm text-n-slate-10">
                    {{ isolationNoTeamStillIsolatedHint }}
                  </p>
                  <p
                    v-if="!isolationTeamOptions.length"
                    class="mb-0 text-sm text-n-slate-10"
                  >
                    {{ isolationNoTeamsHint }}
                  </p>
                </div>
              </template>
            </SettingsToggleSection>

            <SettingsToggleSection
              v-model="pendingStatusEnabled"
              :header="$t('INBOX_MGMT.SETTINGS_POPUP.PENDING_STATUS.TITLE')"
              :description="
                $t('INBOX_MGMT.SETTINGS_POPUP.PENDING_STATUS.SUB_TEXT')
              "
              class="mb-4"
            />

            <SettingsFieldSection
              v-if="isAWebWidgetInbox || isAnEmailChannel"
              :label="$t('INBOX_MGMT.EDIT.SENDER_NAME_SECTION.TITLE')"
              class="[&>div>div]:justify-end [&>div>div]:flex lg:[&>div:first-child]:h-12 [&>div:first-child]:h-16"
            >
              <NextButton
                v-if="!showBusinessNameInput"
                ghost
                blue
                sm
                :label="
                  $t(
                    'INBOX_MGMT.EDIT.SENDER_NAME_SECTION.BUSINESS_NAME.BUTTON_TEXT'
                  )
                "
                @click="onClickShowBusinessNameInput"
              />

              <div
                v-if="showBusinessNameInput"
                v-on-clickaway="hideBusinessNameInput"
                class="flex justify-end gap-2 w-full"
              >
                <input
                  ref="businessNameInput"
                  v-model="businessName"
                  :placeholder="
                    $t(
                      'INBOX_MGMT.EDIT.SENDER_NAME_SECTION.BUSINESS_NAME.PLACEHOLDER'
                    )
                  "
                  class="!mb-0"
                  type="text"
                />
                <NextButton
                  :label="
                    $t(
                      'INBOX_MGMT.EDIT.SENDER_NAME_SECTION.BUSINESS_NAME.SAVE_BUTTON_TEXT'
                    )
                  "
                  class="flex-shrink-0"
                  @click="updateInbox"
                />
              </div>

              <template #extra>
                <SenderNameExamplePreview
                  :sender-name-type="senderNameType"
                  :business-name="businessName"
                  :is-website-channel="isAWebWidgetInbox"
                  @update="toggleSenderNameType"
                />
              </template>
            </SettingsFieldSection>

            <SettingsAccordion
              v-if="isAWebWidgetInbox"
              :title="$t('INBOX_MGMT.WIDGET_FEATURES')"
              class="mt-6"
            >
              <SettingsFieldSection
                :label="
                  $t(
                    'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TITLE.LABEL'
                  )
                "
              >
                <woot-input
                  v-model="channelWelcomeTitle"
                  class="[&>input]:!mb-0"
                  :placeholder="
                    $t(
                      'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TITLE.PLACEHOLDER'
                    )
                  "
                />
              </SettingsFieldSection>

              <SettingsFieldSection
                :label="
                  $t(
                    'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TAGLINE.LABEL'
                  )
                "
                class="[&>div]:!items-start [&>div>label]:mt-1"
              >
                <Editor
                  v-model="channelWelcomeTagline"
                  :placeholder="
                    $t(
                      'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TAGLINE.PLACEHOLDER'
                    )
                  "
                  :max-length="255"
                  channel-type="Context::InboxSettings"
                />
              </SettingsFieldSection>

              <SettingsFieldSection
                :label="$t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.WIDGET_COLOR.LABEL')"
              >
                <div class="justify-start">
                  <ColorPicker v-model="channelWidgetColor" />
                </div>
              </SettingsFieldSection>
              <SettingsFieldSection
                :label="
                  $t('INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE')
                "
              >
                <!--
                  Bloco 3.18 — a regra de precedencia, escrita onde ela e decidida: o banco e o
                  padrao, o `chatwootSettings` do site sobrescreve. Esta tela nao le o HTML do site
                  do cliente, entao ela declara a REGRA em vez de afirmar um override que nao pode
                  verificar. Declarar override ATIVO por campo depende do SDK reportar (bloco 3.09).
                -->
                <Banner color="blue" class="mb-3 !items-start">
                  <div class="flex flex-col gap-1">
                    <span class="font-medium">
                      {{ $t('INBOX_WIDGET.APPEARANCE.SITE_OVERRIDE.TITLE') }}
                    </span>
                    <span>
                      {{ $t('INBOX_WIDGET.APPEARANCE.SITE_OVERRIDE.BODY') }}
                    </span>
                    <span>
                      {{
                        $t('INBOX_WIDGET.APPEARANCE.SITE_OVERRIDE.ACTION_HINT')
                      }}
                    </span>
                  </div>
                </Banner>
                <div class="flex items-center gap-6">
                  <div class="flex items-center gap-2">
                    <label class="text-n-slate-11 text-heading-3">
                      {{
                        $t(
                          'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_POSITION_LABEL'
                        )
                      }}
                    </label>
                    <SelectInput
                      v-model="widgetBubblePosition"
                      :options="[
                        {
                          label: $t(
                            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_POSITION.LEFT'
                          ),
                          value: 'left',
                        },
                        {
                          label: $t(
                            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_POSITION.RIGHT'
                          ),
                          value: 'right',
                        },
                      ]"
                      class="[&>select]:!p-0 min-w-16 [&>select]:!outline-none"
                    />
                  </div>
                  <div class="h-3 w-px bg-n-weak rounded-lg" />
                  <div class="flex items-center gap-2">
                    <label class="text-n-slate-11 text-heading-3">
                      {{
                        $t(
                          'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_TYPE_LABEL'
                        )
                      }}
                    </label>
                    <SelectInput
                      v-model="widgetBubbleType"
                      :options="[
                        {
                          label: $t(
                            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_TYPE.STANDARD'
                          ),
                          value: 'standard',
                        },
                        {
                          label: $t(
                            'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_TYPE.EXPANDED_BUBBLE'
                          ),
                          value: 'expanded_bubble',
                        },
                      ]"
                      class="[&>select]:!p-0 min-w-16 [&>select]:!outline-none"
                    />
                  </div>
                </div>
              </SettingsFieldSection>

              <SettingsFieldSection
                :label="
                  $t(
                    'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_LAUNCHER_TITLE.LABEL'
                  )
                "
              >
                <woot-input
                  v-model="widgetBubbleLauncherTitle"
                  :placeholder="
                    $t(
                      'INBOX_MGMT.WIDGET_BUILDER.WIDGET_OPTIONS.WIDGET_BUBBLE_LAUNCHER_TITLE.PLACE_HOLDER'
                    )
                  "
                  class="[&>input]:!mb-0"
                />
              </SettingsFieldSection>
              <SettingsFieldSection
                :label="$t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.TITLE')"
                :help-text="
                  $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.HELP_TEXT')
                "
              >
                <SelectInput
                  v-model="replyTime"
                  :options="[
                    {
                      value: 'in_a_few_minutes',
                      label: $t(
                        'INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.IN_A_FEW_MINUTES'
                      ),
                    },
                    {
                      value: 'in_a_few_hours',
                      label: $t(
                        'INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.IN_A_FEW_HOURS'
                      ),
                    },
                    {
                      value: 'in_a_day',
                      label: $t(
                        'INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.IN_A_DAY'
                      ),
                    },
                  ]"
                />
              </SettingsFieldSection>

              <SettingsFieldSection
                :label="$t('INBOX_MGMT.FEATURES.LABEL')"
                class="[&>div]:!items-start [&>div>label]:mt-2"
              >
                <div class="flex flex-col gap-1 items-start">
                  <div class="flex gap-2 pt-2 py-0.5">
                    <input
                      v-model="selectedFeatureFlags"
                      type="checkbox"
                      value="attachments"
                      @input="handleFeatureFlag"
                    />
                    <label for="attachments">
                      {{ $t('INBOX_MGMT.FEATURES.DISPLAY_FILE_PICKER') }}
                    </label>
                  </div>
                  <div class="flex gap-2 py-0.5">
                    <input
                      v-model="selectedFeatureFlags"
                      type="checkbox"
                      value="emoji_picker"
                      @input="handleFeatureFlag"
                    />
                    <label for="emoji_picker">
                      {{ $t('INBOX_MGMT.FEATURES.DISPLAY_EMOJI_PICKER') }}
                    </label>
                  </div>
                  <div class="flex gap-2 py-0.5">
                    <input
                      v-model="selectedFeatureFlags"
                      type="checkbox"
                      value="end_conversation"
                      @input="handleFeatureFlag"
                    />
                    <label for="end_conversation">
                      {{ $t('INBOX_MGMT.FEATURES.ALLOW_END_CONVERSATION') }}
                    </label>
                  </div>
                  <div class="flex gap-2 py-0.5">
                    <input
                      v-model="selectedFeatureFlags"
                      type="checkbox"
                      value="use_inbox_avatar_for_bot"
                      @input="handleFeatureFlag"
                    />
                    <label for="use_inbox_avatar_for_bot">
                      {{ $t('INBOX_MGMT.FEATURES.USE_INBOX_AVATAR_FOR_BOT') }}
                    </label>
                  </div>
                </div>
              </SettingsFieldSection>
            </SettingsAccordion>

            <SettingsAccordion
              :title="$t('INBOX_MGMT.CHANNEL_PREFERENCES')"
              class="mt-6"
            >
              <SettingsToggleSection
                v-model="greetingEnabled"
                :header="
                  $t(
                    'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.LABEL'
                  )
                "
                :description="
                  $t(
                    'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.HELP_TEXT'
                  )
                "
              >
                <template v-if="greetingEnabled" #editor>
                  <GreetingsEditor
                    v-model="greetingMessage"
                    :label="
                      $t(
                        'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_MESSAGE.LABEL'
                      )
                    "
                    :placeholder="
                      $t(
                        'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_MESSAGE.PLACEHOLDER'
                      )
                    "
                    :richtext="!textAreaChannels"
                  />
                </template>
              </SettingsToggleSection>

              <SettingsToggleSection
                v-if="isAWebWidgetInbox"
                v-model="emailCollectEnabled"
                :header="
                  $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX')
                "
                :description="
                  $t(
                    'INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT'
                  )
                "
              />

              <SettingsToggleSection
                v-if="isAWebWidgetInbox"
                v-model="allowMessagesAfterResolved"
                :header="
                  $t('INBOX_MGMT.SETTINGS_POPUP.ALLOW_MESSAGES_AFTER_RESOLVED')
                "
                :description="
                  $t(
                    'INBOX_MGMT.SETTINGS_POPUP.ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT'
                  )
                "
              />

              <SettingsToggleSection
                v-if="isAWebWidgetInbox && showContinuityToggle"
                v-model="continuityViaEmail"
                :header="
                  $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_CONTINUITY_VIA_EMAIL')
                "
                :description="continuityDescription"
                :hide-toggle="isContinuityDisabled"
                :class="
                  isContinuityDisabled ? 'cursor-not-allowed opacity-50' : ''
                "
              />
            </SettingsAccordion>

            <div class="w-full flex justify-end items-center py-4 mt-2">
              <NextButton
                v-if="isAPIInbox"
                type="submit"
                :disabled="v$.webhookUrl.$invalid"
                :label="$t('INBOX_MGMT.SETTINGS_POPUP.UPDATE')"
                :is-loading="uiFlags.isUpdating"
                @click="updateInbox"
              />
              <NextButton
                v-else
                type="submit"
                :disabled="v$.$invalid"
                :label="$t('INBOX_MGMT.SETTINGS_POPUP.UPDATE')"
                :is-loading="uiFlags.isUpdating"
                @click="updateInbox"
              />
            </div>
          </div>

          <div
            v-if="isAWebWidgetInbox"
            class="flex-1 sticky top-4 self-start max-w-lg flex-shrink-0 w-full min-w-0"
          >
            <div
              class="flex flex-col outline -outline-offset-1 outline-1 outline-n-weak w-full px-3 pt-3 pb-8 bg-n-surface-1 rounded-2xl min-h-[45rem] overflow-hidden"
            >
              <Widget
                :welcome-heading="channelWelcomeTitle"
                :welcome-tagline="channelWelcomeTagline"
                :website-name="selectedInboxName"
                :logo="avatarUrl"
                is-online
                :reply-time="replyTime"
                :color="channelWidgetColor"
                :widget-bubble-position="widgetBubblePosition"
                :widget-bubble-launcher-title="widgetBubbleLauncherTitle"
                :widget-bubble-type="widgetBubbleType"
                :web-widget-script="inbox.web_widget_script"
                :pre-chat-enabled="inbox.pre_chat_form_enabled"
                :pre-chat-options="inbox.pre_chat_form_options"
              />
            </div>
          </div>
        </div>

        <div v-if="selectedTabKey === 'collaborators'" class="mx-6 max-w-4xl">
          <CollaboratorsPage :inbox="inbox" />
        </div>
        <div
          v-if="selectedTabKey === 'configuration'"
          class="mx-6"
          :class="isAWebWidgetInbox ? 'max-w-7xl' : 'max-w-4xl'"
        >
          <ConfigurationPage :inbox="inbox" />
        </div>
        <div v-if="selectedTabKey === 'csat'">
          <CustomerSatisfactionPage :inbox="inbox" />
        </div>
        <AppearancePage
          v-if="selectedTabKey === 'appearance'"
          ref="appearancePage"
          :inbox-id="currentInboxId"
        />
        <TriggersPage
          v-if="selectedTabKey === 'triggers'"
          ref="triggersPage"
          :inbox-id="currentInboxId"
        />
        <TrackingPage
          v-if="selectedTabKey === 'tracking'"
          ref="trackingPage"
          :inbox-id="currentInboxId"
        />
        <template v-if="selectedTabKey === 'pre-chat-form'">
          <PreChatPage
            v-if="!preChatLegacy"
            ref="preChatPage"
            class="mx-6 max-w-4xl"
            :inbox-id="currentInboxId"
          />
          <PreChatFormSettings v-else :inbox="inbox" />
          <div class="mx-6 max-w-4xl mt-6 mb-4">
            <button
              type="button"
              class="text-sm underline text-n-slate-12 hover:no-underline"
              data-testid="pre-chat-legacy-toggle"
              @click="togglePreChatLegacy"
            >
              {{
                preChatLegacy
                  ? $t('INBOX_WIDGET.PRE_CHAT_FORM.LEGACY.BACK_TO_NEW')
                  : $t('INBOX_WIDGET.PRE_CHAT_FORM.LEGACY.OPEN_OLD')
              }}
            </button>
          </div>
        </template>
        <div v-if="selectedTabKey === 'business-hours'">
          <WeeklyAvailability :inbox="inbox" />
        </div>
        <div v-if="selectedTabKey === 'nps'">
          <NetPromoterScorePage :inbox="inbox" />
        </div>
        <div v-if="selectedTabKey === 'bot-configuration'">
          <BotConfiguration :inbox="inbox" />
        </div>
        <div v-if="selectedTabKey === 'whatsapp-health'">
          <AccountHealth
            :health-data="healthData"
            :health-error="healthError"
            :is-embedded-signup="isEmbeddedSignupWhatsApp"
            :is-registering-webhook="isRegisteringWebhook"
            @register-webhook="registerWebhook"
            @go-to-configuration="goToWhatsAppConfiguration"
          />
        </div>
        <div
          v-if="selectedTabKey === 'message-templates'"
          class="mx-6 max-w-5xl"
        >
          <MessageTemplatesPage :inbox="inbox" />
        </div>
        <WhatsappManualMigrationDialog
          v-if="showWhatsAppManualMigration"
          ref="whatsappManualMigrationDialog"
          :inbox="inbox"
          :is-loading="isTransferringWhatsAppToManual"
          @reconnect="transferWhatsAppToManualSetup"
        />
      </div>
    </section>
  </div>
</template>
